import React from "react";
import { useNavigate } from "react-router-dom";
import { FiArrowRight } from "react-icons/fi";
import qrTile from "../image/Objects.png";
import patternImage from "../image/landing/designer/bg-patterns.webp";
import "./HowItWorks.css";

const steps = [
  {
    number: "1",
    title: "Create Account",
    text: "Sign up and claim your personal TattQR identity in minutes.",
  },
  {
    number: "2",
    title: "Generate QR",
    text: "Get your unique QR tattoo link mapped to your profile.",
  },
  {
    number: "3",
    title: "Upload Content",
    text: "Add image, audio, video, or text and set the active memory.",
  },
  {
    number: "4",
    title: "Configure Privacy",
    text: "Choose permanent or temporary content and optional PIN access.",
  },
  {
    number: "5",
    title: "Scan & Relive",
    text: "Anyone scanning your tattoo experiences the current live story.",
  },
];

const HowItWorks = () => {
  const navigate = useNavigate();

  return (
    <section
      className="how-page"
      style={{ "--how-pattern-image": `url(${patternImage})` }}
    >
      <div className="how-shell">
        <p className="how-kicker">How It Works</p>
        <h1>From Tattoo To Living Story In Five Steps</h1>
        <p className="how-lead">
          The tattoo stays permanent, but what it reveals can evolve whenever
          your story changes.
        </p>

        <div className="how-steps">
          {steps.map((step) => (
            <article key={step.number} className="how-step-card">
              <span className="how-step-index">{step.number}</span>
              <h3>{step.title}</h3>
              <p>{step.text}</p>
            </article>
          ))}
        </div>

        <div className="how-cta">
          <div className="how-cta-copy">
            <h2>
              One Scan, <span>Infinite Memories</span>
            </h2>
            <p>
              Give your tattoo a digital heartbeat and control what each scan
              reveals from your dashboard.
            </p>
            <button type="button" onClick={() => navigate("/signup")}>
              Start My QR Journey
              <FiArrowRight />
            </button>
          </div>
          <div className="how-cta-media">
            <img src={qrTile} alt="TattQR tile" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
